/* Team Cats Order Help (2026-10-15). Front end for the teamcats-order-help Worker; every rule is checked there.
   Says only what the Worker confirmed. No customer details are stored in the browser beyond the 45-minute session token. */
(function () {
  "use strict";
  var root = document.querySelector("[data-tco]");
  if (!root) return;
  var api = root.getAttribute("data-api");
  var form = root.querySelector("[data-tco-lookup]");
  var errorEl = root.querySelector("[data-tco-error]");
  var view = root.querySelector("[data-tco-view]");
  var state = { token: null, model: null };
  var STATES = ["AL","AZ","AR","CA","CO","CT","DE","DC","FL","GA","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];

  // Anonymous page counts (fixed event names only). Nothing is sent when the visitor asks not to be tracked.
  var sentEvents = {};
  function trackingAllowed() {
    if (root.getAttribute("data-analytics") === "false") return false;
    if (window.Shopify && window.Shopify.designMode) return false;
    if (/^(localhost|127\.0\.0\.1)$/.test(location.hostname)) return false;
    if (navigator.doNotTrack === "1" || window.doNotTrack === "1" || navigator.globalPrivacyControl === true) return false;
    try { var cp = window.Shopify && window.Shopify.customerPrivacy; if (cp && typeof cp.analyticsProcessingAllowed === "function" && !cp.analyticsProcessingAllowed()) return false; } catch (e) {}
    return true;
  }
  function track(event) {
    if (sentEvents[event] || !trackingAllowed()) return;
    sentEvents[event] = true;
    var body = JSON.stringify({ action: "track", event: event });
    try { if (navigator.sendBeacon && navigator.sendBeacon(api, new Blob([body], { type: "text/plain" }))) return; } catch (e) {}
    try { fetch(api, { method: "POST", headers: { "content-type": "text/plain" }, body: body, keepalive: true }).catch(function () {}); } catch (e) {}
  }
  track("view");
  document.querySelectorAll("[data-tco-size]").forEach(function (d) { d.addEventListener("toggle", function () { if (d.open) track("open_size"); }); });

  var STAGE = { before_export: "Being prepared", exported: "With our packing partner", shipped: "Shipped", partly_shipped: "Partly shipped", cancelled: "Cancelled", unknown: "Received" };
  var REFUND_NOTE = { not_shipped: "Not shipped yet.", exchange_order: "This is an exchange order.", already_requested: "A refund was already requested.", not_refundable: "This item can't be refunded here.", cancelled: "This order was cancelled." };
  var SWAP_NOTE = { custom_item: "Custom items: use “Something else” below and we'll help." };

  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === "text") el.textContent = attrs[k];
      else if (k === "class") el.className = attrs[k];
      else if (k.indexOf("on") === 0) el.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) el.setAttribute(k, attrs[k] === true ? "" : attrs[k]);
    });
    (kids || []).forEach(function (kid) { if (kid) el.appendChild(typeof kid === "string" ? document.createTextNode(kid) : kid); });
    return el;
  }
  function money(n) { return "$" + Number(n || 0).toFixed(2); }
  function day(iso) { try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); } catch (e) { return ""; } }
  function ref(prefix) {
    var bytes = new Uint8Array(6);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    return prefix + "-" + Array.prototype.map.call(bytes, function (b) { return ("0" + b.toString(16)).slice(-2); }).join("");
  }
  function call(body) {
    // The visit's recording (Merchanting Watch) goes with each action, so the team's Slack line can link to it.
    var watch = window.MerchantingWatch && window.MerchantingWatch.sessionId;
    if (watch && body.action !== "lookup" && body.action !== "order") body = Object.assign({ watchSession: watch }, body);
    return fetch(api, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (data) { if (!r.ok) { var e = new Error(data.message || "Something went wrong. Please try again."); e.code = data.error; throw e; } if (data && data.ref && data.kind && data.kind !== "preview") state.lastAction = { ref: data.ref, kind: data.action || data.kind }; return data; }); });
  }
  function busy(button, on, label) {
    if (!button) return;
    if (on) { button.setAttribute("data-label", button.textContent); button.textContent = label || "One moment…"; button.disabled = true; }
    else { button.textContent = button.getAttribute("data-label") || button.textContent; button.disabled = false; }
  }
  function expired(err) {
    if (err && err.code === "session_expired") { state.token = null; view.hidden = true; form.hidden = false; showError(err.message); return true; }
    return false;
  }
  function showError(msg) { errorEl.textContent = msg; errorEl.hidden = !msg; }

  form.addEventListener("submit", function (ev) {
    ev.preventDefault();
    showError("");
    var number = form.orderNumber.value.trim(), identity = form.identity.value.trim();
    if (!number || !identity) { showError("Enter your order number and the email you used at checkout."); return; }
    var button = form.querySelector("button");
    track("lookup_start");
    busy(button, true, "Looking it up…");
    call({ action: "lookup", orderNumber: number, identity: identity }).then(function (data) {
      state.token = data.token; state.model = data;
      form.hidden = true; render();
    }).catch(function (err) { showError(err.message); }).then(function () { busy(button, false); });
  });

  function refresh(banner) {
    return call({ action: "order", token: state.token }).then(function (data) { state.model = Object.assign({}, data, { token: state.token }); render(banner); })
      .catch(function (err) { if (!expired(err)) render(banner); });
  }

  function render(banner) {
    var m = state.model;
    view.innerHTML = "";
    if (banner) view.appendChild(banner);
    var head = h("div", { class: "tco-card tco-head" }, [
      h("div", null, [h("p", { class: "tco-kicker", text: "Order " + m.order.name }), h("h3", { class: "tco-stage", tabindex: "-1", "data-tco-focus": true, text: STAGE[m.order.stage] || "Received" })]),
      h("p", { class: "tco-meta", text: "Placed " + day(m.order.placedAt) + " · " + money(m.order.total) })
    ]);
    view.appendChild(head);
    if (m.verifiedBy !== "email") view.appendChild(h("p", { class: "tco-note", text: "You looked this order up with a ZIP code, so you can see its status. To make a change, look it up with the email from your order." }));

    if (m.packages && m.packages.length) {
      var list = h("ul", { class: "tco-packages" });
      m.packages.forEach(function (p) {
        list.appendChild(h("li", { class: "tco-card tco-pkg tco-pkg--" + p.key }, [
          h("p", null, [h("b", { text: p.status }), p.deliveredAt && p.key === "delivered" ? " · " + day(p.deliveredAt) : ""]),
          p.lastEvent && p.key !== "delivered" ? h("p", { class: "tco-meta", text: p.lastEvent }) : null,
          p.number ? h("p", { class: "tco-meta" }, [(p.carrier ? p.carrier + " " : "") + p.number + " ", /^https:\/\//.test(p.url || "") ? h("a", { class: "tkh-link", href: p.url, target: "_blank", rel: "noopener", text: "Track" }) : null]) : null,
          p.items && p.items.length ? h("p", { class: "tco-meta", text: p.items.join(", ") }) : null
        ]));
      });
      view.appendChild(h("h3", { class: "tco-h3", text: "Packages" }));
      view.appendChild(list);
    } else if (m.order.stage !== "cancelled") {
      view.appendChild(h("p", { class: "tco-note", text: "No tracking yet. You'll see it here as soon as your order ships." }));
    }

    view.appendChild(h("h3", { class: "tco-h3", text: "Items" }));
    var items = h("ul", { class: "tco-items" });
    m.items.forEach(function (item) { items.appendChild(itemCard(item)); });
    view.appendChild(items);

    var actions = h("div", { class: "tco-order-actions" });
    if (m.address && m.address.ok && m.verifiedBy === "email") actions.appendChild(h("button", { type: "button", class: "tkh-btn tkh-btn--ghost", text: "Change address", onclick: function () { addressFlow(); } }));
    if (m.cancel.ok && m.verifiedBy === "email") actions.appendChild(h("button", { type: "button", class: "tkh-btn tkh-btn--ghost", text: "Cancel this order", onclick: function (e) { cancelFlow(e.currentTarget); } }));
    if (m.verifiedBy === "email") actions.appendChild(h("button", { type: "button", class: "tkh-btn tkh-btn--ghost", text: "Something else", onclick: function (e) { helpFlow(e.currentTarget); } }));
    actions.appendChild(h("button", { type: "button", class: "tco-linkbtn", text: "Look up another order", onclick: function () { state.token = null; view.hidden = true; form.hidden = false; form.reset(); form.orderNumber.focus(); } }));
    view.appendChild(actions);
    view.hidden = false;
    var focusTarget = banner || view.querySelector("[data-tco-focus]");
    if (focusTarget) { focusTarget.setAttribute("tabindex", "-1"); focusTarget.focus({ preventScroll: true }); focusTarget.scrollIntoView({ behavior: "smooth", block: "center" }); }
  }

  function itemCard(item) {
    var m = state.model;
    var canAct = m.verifiedBy === "email";
    var li = h("div", { class: "tco-card tco-item" }, [
      item.image ? h("img", { src: item.image, alt: "", width: 72, height: 72, loading: "lazy" }) : h("span", { class: "tco-noimg" }),
      h("div", { class: "tco-item-copy" }, [
        h("p", null, [h("b", { text: item.title })]),
        item.variantTitle ? h("p", { class: "tco-meta", text: item.variantTitle }) : null,
        h("p", { class: "tco-meta", text: "Qty " + item.quantity + (item.deliveredAt ? " · delivered " + day(item.deliveredAt) : item.shipped ? " · on the way" : "") })
      ])
    ]);
    var buttons = h("div", { class: "tco-item-actions" });
    var panel = h("div", { class: "tco-panel", hidden: true });
    if (canAct && item.exchange.ok && (item.exchange.options.length || item.exchange.team)) buttons.appendChild(h("button", { type: "button", class: "tkh-btn tkh-btn--ghost", text: "Exchange it", onclick: function () { swapFlow(item, panel); } }));
    if (canAct && item.refund.ok) buttons.appendChild(h("button", { type: "button", class: "tkh-btn tkh-btn--ghost", text: "Get a refund", onclick: function (e) { refundFlow(item, panel, e.currentTarget); } }));
    if (canAct && item.claim && item.claim.ok) buttons.appendChild(h("button", { type: "button", class: "tkh-btn tkh-btn--ghost", text: "Report a problem", onclick: function () { claimFlow(item, panel); } }));
    var note = !item.addOn && ((!item.refund.ok && REFUND_NOTE[item.refund.why]) || (!item.exchange.ok && SWAP_NOTE[item.exchange.why]) || (!item.refund.ok && item.refund.why === "past_window" ? "Delivered more than " + m.windowDays + " days ago. Use “Something else” and we'll take a look." : ""));
    var wrap = h("div", { class: "tco-item-side" }, [buttons, note ? h("p", { class: "tco-meta", text: note }) : null]);
    li.appendChild(wrap);
    return h("li", { class: "tco-item-wrap" }, [li, panel]);
  }

  function openPanel(panel, kids) {
    document.querySelectorAll(".tco-panel").forEach(function (p) { if (p !== panel) { p.hidden = true; p.innerHTML = ""; } });
    panel.innerHTML = ""; kids.forEach(function (k) { if (k) panel.appendChild(k); }); panel.hidden = false;
    var title = panel.querySelector("p");
    if (title) { title.setAttribute("tabindex", "-1"); title.focus({ preventScroll: true }); title.scrollIntoView({ behavior: "smooth", block: "nearest" }); }
  }
  function closeBtn(panel) {
    return h("button", { type: "button", class: "tco-linkbtn", text: "Never mind", onclick: function () {
      panel.hidden = true; panel.innerHTML = "";
      var heading = view.querySelector("[data-tco-focus]"); if (heading) heading.focus({ preventScroll: true });
    } });
  }
  function done(kind, title, text) {
    var box = h("div", { class: "tco-card tco-done tco-done--" + kind, role: "status" }, [h("p", null, [h("b", { text: title })]), text ? h("p", { text: text }) : null]);
    var last = state.lastAction; state.lastAction = null;
    if (last) box.appendChild(rateBlock(last));
    return box;
  }
  /* "How was this?" after a finished action (as on Team K9's support page): Easy, Okay or Hard; Okay and Hard can say what
     would have made it easier. Sent quietly; the page never waits for it. */
  function rateBlock(last) {
    var box = h("div", { class: "tco-rate", role: "group", "aria-label": "How was this?" });
    function send(extra) {
      try { fetch(api, { method: "POST", keepalive: true, headers: { "content-type": "application/json" }, body: JSON.stringify(Object.assign({ action: "feedback", token: state.token, ref: last.ref, kind: last.kind }, extra)) }).catch(function () {}); } catch (e) { /* never in the customer's way */ }
    }
    function thanks() { box.innerHTML = ""; box.appendChild(h("p", { class: "tco-rate-done", role: "status", text: "Thanks, that helps us make this better." })); }
    box.appendChild(h("p", { class: "tco-rate-q", text: "How was this?" }));
    box.appendChild(h("div", { class: "tco-rate-row" }, [["easy", "Easy"], ["okay", "Okay"], ["hard", "Hard"]].map(function (o) {
      return h("button", { type: "button", class: "tco-chip", text: o[1], onclick: function () {
        send({ score: o[0] });
        if (o[0] === "easy") { thanks(); return; }
        box.innerHTML = "";
        var note = h("textarea", { class: "tco-text", rows: 2, maxlength: 400, placeholder: "Optional", "aria-label": "What would have made it easier?" });
        box.appendChild(h("p", { class: "tco-rate-q", text: "What would have made it easier?" }));
        box.appendChild(note);
        box.appendChild(h("div", { class: "tco-rate-row" }, [
          h("button", { type: "button", class: "tkh-btn tkh-btn--acc", text: "Send", onclick: function () { if (note.value.trim()) send({ score: o[0], comment: note.value.trim() }); thanks(); } }),
          h("button", { type: "button", class: "tco-linkbtn", text: "Skip", onclick: thanks })
        ]));
        note.focus();
      } });
    })));
    return box;
  }
  function fail(panel, err) {
    if (expired(err)) return;
    var p = panel.querySelector(".tco-error") || panel.appendChild(h("p", { class: "tco-error", role: "alert" }));
    p.textContent = err.message;
  }
  function requestDone(data) {
    return done("team", "Sent to our team", "Our team will review it and reply by email.");
  }

  function swapFlow(item, panel) {
    track("open_exchange");
    var r = ref("exc");
    var options = item.exchange.options || [];
    var group = h("div", { class: "tco-options", role: "radiogroup", "aria-label": "Choose what you'd like instead" });
    options.forEach(function (o, i) {
      group.appendChild(h("label", { class: "tco-option" }, [h("input", { type: "radio", name: "tco-swap-" + item.id, value: o.variantId, checked: i === 0 }), h("span", { text: o.title })]));
    });
    var note = h("textarea", { class: "tco-text", rows: 2, maxlength: 300, placeholder: "Anything we should know? (optional)", "aria-label": "Anything we should know? (optional)" });
    var go = h("button", { type: "button", class: "tkh-btn tkh-btn--acc", text: options.length && !item.exchange.team ? "Exchange it for free" : "Ask for an exchange" });
    go.addEventListener("click", function () {
      var picked = group.querySelector("input:checked");
      busy(go, true);
      call({ action: "exchange", token: state.token, lineItemId: item.id, variantId: picked ? picked.value : null, note: note.value, ref: r }).then(function (data) {
        var banner = data.kind === "exchanged"
          ? done("ok", "Exchange done", data.lane === "edit" ? "We changed " + (data.from || "it") + " to " + data.to + " on your order before it shipped. Same price." : "Your free exchange order is " + data.newOrder + " (" + data.to + "). Nothing to send back: keep the original or donate it.")
          : requestDone(data);
        refresh(banner);
      }).catch(function (err) { busy(go, false); fail(panel, err); });
    });
    var hasSize = (item.exchange.options || []).some(function (o) { return (o.options || []).some(function (x) { return /size/i.test(x.name || ""); }); });
    var sizeLink = hasSize && document.getElementById("size-help") ? h("p", { class: "tco-meta" }, [h("a", { class: "tkh-link", href: "#size-help", text: "Not sure which size? See size help" })]) : null;
    openPanel(panel, [h("p", null, [h("b", { text: "Exchange " + item.title })]), sizeLink, item.exchange.team ? h("p", { class: "tco-meta", text: "Our team will review it and reply by email. Nothing to send back." }) : h("p", { class: "tco-meta", text: "Same product, same price. Nothing to send back." }), options.length ? group : null, note, h("div", { class: "tco-row" }, [go, closeBtn(panel)])]);
  }

  function refundFlow(item, panel, button) {
    track("open_refund");
    var r = ref("ref");
    busy(button, true, "Checking…");
    call({ action: "refund", token: state.token, lineItemId: item.id, quantity: item.refundableQuantity, preview: true, ref: r }).then(function (data) {
      busy(button, false);
      var plan = data.plan || {};
      var reason = h("textarea", { class: "tco-text", rows: 2, maxlength: 300, placeholder: "What happened? (optional)", "aria-label": "What happened? (optional)" });
      var go = h("button", { type: "button", class: "tkh-btn tkh-btn--acc", text: plan.lane === "instant" ? "Refund " + money(plan.amount) : "Send my refund request" });
      go.addEventListener("click", function () {
        busy(go, true);
        call({ action: "refund", token: state.token, lineItemId: item.id, quantity: item.refundableQuantity, reason: reason.value, ref: r }).then(function (res) {
          refresh(res.kind === "refunded" ? done("ok", "Refunded " + money(res.amount), "It's on its way back to your original payment. You'll get a receipt by email; your bank decides when it shows up. Keep the item or donate it.") : requestDone(res));
        }).catch(function (err) { busy(go, false); fail(panel, err); });
      });
      openPanel(panel, [
        h("p", null, [h("b", { text: "Refund " + item.title })]),
        h("p", { class: "tco-meta", text: plan.lane === "instant" ? "We'll refund " + money(plan.amount) + " to your original payment right now. Nothing to send back." : "Our team will review it and reply by email. Nothing to send back." }),
        reason, h("div", { class: "tco-row" }, [go, closeBtn(panel)])
      ]);
    }).catch(function (err) { busy(button, false); fail(panel, err); panel.hidden = false; });
  }

  function cancelFlow(button) {
    track("open_cancel");
    var r = ref("cxl");
    var panel = view.querySelector(".tco-order-panel") || view.appendChild(h("div", { class: "tco-panel tco-order-panel" }));
    busy(button, true, "Checking…");
    call({ action: "cancel", token: state.token, preview: true, ref: r }).then(function (data) {
      busy(button, false);
      var plan = data.plan || {};
      var reason = h("textarea", { class: "tco-text", rows: 2, maxlength: 300, placeholder: "Reason (optional)", "aria-label": "Reason for cancelling (optional)" });
      var go = h("button", { type: "button", class: "tkh-btn tkh-btn--acc", text: plan.lane === "instant" || plan.lane === "refund" ? "Cancel and refund " + money(plan.total) : "Send my cancel request" });
      go.addEventListener("click", function () {
        busy(go, true);
        call({ action: "cancel", token: state.token, reason: reason.value, ref: r }).then(function (res) {
          refresh(res.kind === "cancelled" ? done("ok", "Your cancellation is in", "You'll get an email when it's done, and your payment goes back to your original payment method.")
            : res.kind === "cancel_refunded" ? done("ok", "Cancelled and refunded " + money(res.amount), "It's on its way back to your original payment. You'll get a receipt by email; your bank decides when it shows up. If the package still arrives, keep it or donate it.") : requestDone(res));
        }).catch(function (err) { busy(go, false); fail(panel, err); });
      });
      openPanel(panel, [h("p", null, [h("b", { text: "Cancel order " + state.model.order.name })]),
        h("p", { class: "tco-meta", text: plan.lane === "instant" ? "It hasn't gone to our packing partner yet, so we can cancel it now for free."
          : plan.lane === "refund" ? (plan.onTheWay ? "It's already on its way" : "It's already with our packing partner") + ", so we'll refund you now" + (state.model.items.some(function (i) { return i.deliveredAt; }) ? " for everything not delivered yet" : "") + ". If it still arrives, there's nothing to send back: keep it or donate it."
          : "Our team will review it and reply by email." }),
        reason, h("div", { class: "tco-row" }, [go, closeBtn(panel)])]);
    }).catch(function (err) { busy(button, false); fail(panel, err); panel.hidden = false; });
  }

  function helpFlow() {
    track("open_help");
    var r = ref("hlp");
    var panel = view.querySelector(".tco-order-panel") || view.appendChild(h("div", { class: "tco-panel tco-order-panel" }));
    var topic = h("select", { class: "tco-text", "aria-label": "What's going on?" }, [["damaged", "Something arrived damaged"], ["missing", "Something's missing"], ["not_received", "Says delivered, but it's not here"], ["other", "Something else"]].map(function (o) { return h("option", { value: o[0], text: o[1] }); }));
    var message = h("textarea", { class: "tco-text", rows: 4, maxlength: 2000, placeholder: "Tell us what happened", "aria-label": "Tell us what happened" });
    var go = h("button", { type: "button", class: "tkh-btn tkh-btn--acc", text: "Send to our team" });
    go.addEventListener("click", function () {
      if (message.value.trim().length < 3) { fail(panel, new Error("Please tell us a little about what's going on.")); return; }
      busy(go, true);
      call({ action: "help", token: state.token, topic: topic.value, message: message.value, ref: r }).then(function () {
        refresh(done("team", "Sent to our team", "Our team will review it and reply by email."));
      }).catch(function (err) { busy(go, false); fail(panel, err); });
    });
    openPanel(panel, [h("p", null, [h("b", { text: "How can we help?" })]), topic, message, h("div", { class: "tco-row" }, [go, closeBtn(panel)])]);
  }

  /* Shrinks a photo on the phone before upload (longest side 1600 px, JPEG). */
  function shrink(file) {
    return new Promise(function (resolve) {
      if (!file || !/^image\//.test(file.type)) { resolve(null); return; }
      var reader = new FileReader();
      reader.onload = function () {
        var img = new Image();
        img.onload = function () {
          var scale = Math.min(1, 1600 / Math.max(img.width, img.height));
          var canvas = document.createElement("canvas");
          canvas.width = Math.round(img.width * scale); canvas.height = Math.round(img.height * scale);
          canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
          try { resolve(canvas.toDataURL("image/jpeg", 0.8)); } catch (e) { resolve(null); }
        };
        img.onerror = function () { resolve(null); };
        img.src = reader.result;
      };
      reader.onerror = function () { resolve(null); };
      reader.readAsDataURL(file);
    });
  }

  function claimFlow(item, panel) {
    track("open_claim");
    var r = ref("clm");
    var types = [["damaged", "Arrived damaged"], ["defective", "Broke or stopped working"], ["wrong_item", "Wrong item"], ["missing", "Something's missing"]];
    var group = h("div", { class: "tco-options", role: "radiogroup", "aria-label": "What happened?" });
    types.forEach(function (t, i) { group.appendChild(h("label", { class: "tco-option" }, [h("input", { type: "radio", name: "tco-claim-" + item.id, value: t[0], checked: i === 0 }), h("span", { text: t[1] })])); });
    var photos = [];
    var thumbs = h("div", { class: "tco-thumbs", "aria-live": "polite" });
    var file = h("input", { type: "file", accept: "image/*", multiple: true, class: "tco-file", id: "tco-file-" + r });
    var fileLabel = h("label", { class: "tkh-btn tkh-btn--ghost tco-filebtn", for: "tco-file-" + r, text: "Add photos" });
    file.addEventListener("change", function () {
      Array.prototype.slice.call(file.files, 0, Math.max(0, 3 - photos.length)).forEach(function (f) {
        shrink(f).then(function (url) {
          if (!url || photos.length >= 3) return;
          photos.push(url);
          thumbs.appendChild(h("img", { src: url, alt: "Photo " + photos.length + " added", width: 64, height: 64 }));
        });
      });
      file.value = "";
    });
    var note = h("textarea", { class: "tco-text", rows: 2, maxlength: 1000, placeholder: "What happened? (optional)", "aria-label": "What happened? (optional)" });
    var go = h("button", { type: "button", class: "tkh-btn tkh-btn--acc", text: "Send report" });
    var hint = h("p", { class: "tco-meta", text: item.claim.team ? "Our team will review it and reply by email. Nothing to send back." : "Add a photo of the problem. Nothing to send back." });
    group.addEventListener("change", function () {
      var missing = (group.querySelector("input:checked") || {}).value === "missing";
      hint.textContent = missing || item.claim.team ? "Our team will review it and reply by email. Nothing to send back." : "Add a photo of the problem. Nothing to send back.";
    });
    go.addEventListener("click", function () {
      var picked = (group.querySelector("input:checked") || {}).value || "damaged";
      busy(go, true, "Sending…");
      call({ action: "claim", token: state.token, lineItemId: item.id, type: picked, note: note.value, photos: photos, ref: r }).then(function (res) {
        refresh(res.kind === "replaced" ? done("ok", "Replacement on its way", "Your free replacement order is " + res.newOrder + ". Nothing to send back.") : requestDone(res));
      }).catch(function (err) { busy(go, false); fail(panel, err); });
    });
    var refundBtn = item.refund && item.refund.ok ? h("button", { type: "button", class: "tkh-btn tkh-btn--ghost", text: "Refund me instead", onclick: function (e) { refundFlow(item, panel, e.currentTarget); } }) : null;
    openPanel(panel, [h("p", null, [h("b", { text: "Report a problem with " + item.title })]), hint, group, h("div", { class: "tco-row" }, [file, fileLabel]), thumbs, note, h("div", { class: "tco-row" }, [go, refundBtn, closeBtn(panel)])]);
  }

  function addressFlow(typed) {
    track("open_address");
    var r = ref("adr");
    var m = state.model;
    var panel = view.querySelector(".tco-order-panel") || view.appendChild(h("div", { class: "tco-panel tco-order-panel" }));
    var cur = typed || (m.address && m.address.current) || {};
    var names = typed ? [typed.firstName || "", typed.lastName || ""] : String(cur.name || "").split(" ");
    function field(label, name, value, attrs) {
      var input = h("input", Object.assign({ name: name, value: value || "", class: "tco-text", autocomplete: (attrs && attrs.autocomplete) || "off" }, attrs || {}));
      return h("label", { class: "tco-field" }, [h("span", { text: label }), input]);
    }
    var state1 = h("select", { name: "provinceCode", class: "tco-text", autocomplete: "address-level1" }, [h("option", { value: "", text: "Choose a state", selected: STATES.indexOf(cur.provinceCode) < 0 })].concat(STATES.map(function (code) { return h("option", { value: code, text: code, selected: code === cur.provinceCode }); })));
    var formEl = h("form", { class: "tco-addr", novalidate: true }, [
      h("div", { class: "tco-fields" }, [field("First name", "firstName", names[0], { autocomplete: "given-name" }), field("Last name", "lastName", names.slice(1).join(" "), { autocomplete: "family-name" })]),
      field("Street address", "address1", cur.address1, { autocomplete: "address-line1", required: true }),
      field("Apartment, suite (optional)", "address2", cur.address2, { autocomplete: "address-line2" }),
      h("div", { class: "tco-fields tco-fields--3" }, [field("City", "city", cur.city, { autocomplete: "address-level2", required: true }), h("label", { class: "tco-field" }, [h("span", { text: "State" }), state1]), field("ZIP", "zip", cur.zip, { autocomplete: "postal-code", inputmode: "numeric", required: true })]),
      field("Phone (optional)", "phone", cur.phone || "", { autocomplete: "tel", type: "tel" })
    ]);
    var go = h("button", { type: "button", class: "tkh-btn tkh-btn--acc", text: "Check new address" });
    go.addEventListener("click", function () {
      var data = {};
      ["firstName", "lastName", "address1", "address2", "city", "zip", "phone"].forEach(function (k) { data[k] = formEl.elements[k].value.trim(); });
      data.provinceCode = state1.value;
      busy(go, true, "Checking…");
      call({ action: "address", token: state.token, address: data, preview: true, ref: r }).then(function (pre) {
        busy(go, false);
        var plan = pre.plan || {};
        var confirm = h("button", { type: "button", class: "tkh-btn tkh-btn--acc", text: plan.lane === "instant" ? "Save new address" : "Send to our team" });
        confirm.addEventListener("click", function () {
          busy(confirm, true);
          call({ action: "address", token: state.token, address: data, ref: r }).then(function (res) {
            refresh(res.kind === "address_updated" ? done("ok", "Address updated", "Your order will ship to: " + res.address + ".") : requestDone(res));
          }).catch(function (err) { busy(confirm, false); fail(panel, err); });
        });
        openPanel(panel, [h("p", null, [h("b", { text: "Ship to:" })]), h("p", { text: plan.address }),
          h("p", { class: "tco-meta", text: plan.lane === "instant" ? "We'll update your order right now." : "Our team will review it and reply by email." }),
          h("div", { class: "tco-row" }, [confirm, h("button", { type: "button", class: "tco-linkbtn", text: "Edit", onclick: function () { addressFlow(data); } }), closeBtn(panel)])]);
      }).catch(function (err) { busy(go, false); fail(panel, err); });
    });
    openPanel(panel, [h("p", null, [h("b", { text: "Change shipping address" })]), h("p", { class: "tco-meta", text: "We ship to the continental United States." }), formEl, h("div", { class: "tco-row" }, [go, closeBtn(panel)])]);
  }
})();
